
import React, { Suspense } from 'react';
import { DynamicManifest } from '@/components/DynamicManifest';
import RoutesWrapper from './RoutesWrapper';
import { SEO } from "./SEO";

const AppContent: React.FC = () => {
  return (
    <>
      <DynamicManifest />
      <SEO 
        pageType="website"
        title="HTML5 Games 🎮 | Play Free Online Games Without Download"
        description="Play thousands of free online games at TerraGamers. No downloads required!"
        keywords="free games, online games, web games, browser games"
      />
      <div className="min-h-screen flex flex-col bg-background">
        <Suspense fallback={
          <div className="min-h-screen flex items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          </div>
        }>
          <RoutesWrapper />
        </Suspense>
      </div>
    </>
  );
};

export default AppContent;
